import { SESSIONS, fmtPnl } from "@/lib/trading";

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

const cellStyle = (pnl, max) => {
  if (!pnl) return { background: "#161C26" };
  const a = 0.15 + 0.7 * Math.min(Math.abs(pnl) / (max || 1), 1);
  return { background: pnl > 0 ? `rgba(16,185,129,${a})` : `rgba(239,68,68,${a})` };
};

export const SessionHeatmap = ({ heatmap }) => {
  const max = Math.max(0, ...SESSIONS.flatMap((s) => heatmap[s.key].map((c) => Math.abs(c.pnl))));
  return (
    <div className="panel p-5 mt-6 overflow-x-auto" data-testid="session-heatmap">
      <div className="flex flex-wrap justify-between gap-2 mb-4">
        <p className="text-xs font-mono uppercase tracking-wider text-slate-500">Session × weekday heatmap (UTC)</p>
        <div className="flex items-center gap-2 text-[11px] font-mono text-slate-500">
          <span className="h-2.5 w-2.5 rounded-sm bg-red-500/70" />Loss<span className="h-2.5 w-2.5 rounded-sm bg-emerald-500/70 ml-2" />Profit
        </div>
      </div>
      <div className="grid grid-cols-[90px_repeat(7,minmax(70px,1fr))] gap-1.5 min-w-[640px]">
        <div />
        {DAYS.map((d) => <div key={d} className="text-center text-[11px] font-mono text-slate-500 pb-1">{d}</div>)}
        {SESSIONS.map((s) => (
          <div key={s.key} className="contents">
            <div className="flex items-center text-xs font-mono" style={{ color: s.color }}>{s.label}</div>
            {heatmap[s.key].map((c, i) => (
              <div key={i} style={cellStyle(c.pnl, max)} data-testid={`heatmap-cell-${s.key}-${DAYS[i].toLowerCase()}`}
                title={`${s.label} · ${DAYS[i]}: ${fmtPnl(c.pnl)} (${c.trades} trades)`}
                className="rounded-md px-2 py-2.5 text-center transition-transform hover:scale-105">
                <p className={`font-mono text-xs font-semibold ${c.trades ? "text-white" : "text-slate-600"}`}>{c.trades ? fmtPnl(c.pnl) : "—"}</p>
                <p className="font-mono text-[10px] text-white/60">{c.trades ? `${c.trades} tr` : ""}</p>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
